import React from 'react';
import MainLayout from '../layouts/MainLayout';
import ContactForm from '../components/ContactForm';
import { pageMeta } from '../lib/seo';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { Card, CardContent } from '../components/Card';

const ContactPage = () => {
  const contactInfo = [
    {
      icon: Phone,
      title: 'Telefon',
      value: '+49178 3620226',
      link: 'tel:+491783620226',
      description: 'Mo-Fr: 08:00 - 18:00 Uhr'
    },
    {
      icon: Mail,
      title: 'E-Mail',
      value: 'kontakt@senkay-personallogistik.de',
      link: 'mailto:kontakt@senkay-personallogistik.de',
      description: 'Wir antworten innerhalb von 24h'
    },
    {
      icon: MapPin,
      title: 'Adresse',
      value: 'Georg-Maurer-Weg 11, 80995 München',
      description: 'Deutschland'
    },
    {
      icon: Clock,
      title: 'Öffnungszeiten',
      value: 'Mo-Fr: 08:00 - 18:00',
      description: 'Termine nach Vereinbarung'
    }
  ];

  return (
    <MainLayout
      title={pageMeta.contact.title}
      description={pageMeta.contact.description}
      keywords={pageMeta.contact.keywords}
    >
      {/* Contact Form */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 md:pt-24 pb-16 md:pb-24">
        <div className="max-w-4xl mx-auto mb-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-primary-text-dark mb-4">
            Kontaktformular
          </h1>
          <p className="text-lg text-primary-text-muted">
            Haben Sie Fragen zu unseren Leistungen oder möchten Sie ein Angebot anfordern?
            Füllen Sie das Formular aus und wir melden uns schnellstmöglich bei Ihnen.
          </p>
        </div>
        <ContactForm />
      </section>

      {/* Contact Info Cards */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {contactInfo.map((info, index) => (
            <Card key={index} className="text-center">
              <CardContent>
                <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-primary-blue-light flex items-center justify-center">
                  <info.icon className="w-7 h-7 text-primary-blue-mid" />
                </div>
                <h3 className="font-semibold text-primary-text-dark mb-2">
                  {info.title}
                </h3>
                {info.link ? (
                  <a
                    href={info.link}
                    className="text-primary-blue-mid hover:underline block mb-1"
                  >
                    {info.value}
                  </a>
                ) : (
                  <p className="text-primary-text-dark mb-1">{info.value}</p>
                )}
                <p className="text-sm text-primary-text-muted">
                  {info.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>

      {/* Map */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        <div className="mb-6 text-center">
          <h3 className="text-2xl font-semibold text-primary-text-dark mb-2">
            Standort München
          </h3>
          <p className="text-primary-text-muted">
            Georg-Maurer-Weg 11, 80995 München
          </p>
        </div>
        <Card>
          <CardContent className="p-0">
            <div className="w-full h-96 rounded-lg overflow-hidden">
              <iframe
                src="https://www.google.com/maps?q=Georg-Maurer-Weg+11,+80995+München&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="SENKAY Standort München"
              />
            </div>
          </CardContent>
        </Card>
      </section>
    </MainLayout>
  );
};

export default ContactPage;
